/**
 * Blog posts data for the cosmic blog section.
 * Keyed by slug; each post has date, category, readTime, title, tags, excerpt, content (HTML),
 * optional featured, and overlayBackground (determines the modal overlay/background style).
 *
 * overlayBackground: 'default' | 'evm-cosmic' | <custom class suffix>
 * - 'default': standard dark overlay
 * - 'evm-cosmic': cosmic modal style from the second mockup image (deep space gradient + starfield)
 * - or any string: applied as class suffix blog-modal-overlay--<value> and blog-modal-container--<value>
 */

export const blogPosts = {
  'evm-storage': {
    date: 'Feb 26, 2026',
    category: 'Blockchain',
    readTime: '15 min read',
    title: 'The EVM Galaxy: A Visual Journey Through Smart Contract Storage',
    overlayBackground: 'evm-cosmic',
    tags: ['Ethereum', 'Solidity', 'EVM', 'EIP-7201', 'Storage'],
    excerpt:
      'Explore Ethereum Virtual Machine storage through a unique cosmic analogy with interactive visualizations. Learn how smart contracts organize storage, understand sequential vs hashed allocation, and discover how EIP-7201 prevents collision in upgradeable contracts.',
    featured: true,
    // Content is rendered by the EVMGalaxy component directly in ArticleModal
    content: '',
  },

  // TODO: uncomment when Calls vs Delegatecall article is ready
  // 'calls-and-delegatecall': {
  //   date: 'Mar 8, 2026',
  //   category: 'Blockchain',
  //   readTime: '10 min read',
  //   title: 'Calls vs Delegatecall: A virtual journey how laws are shared',
  //   overlayBackground: 'evm-cosmic',
  //   tags: ['Ethereum', 'Solidity', 'EVM', 'call', 'delegatecall', 'Proxy'],
  //   excerpt:
  //     'Understand the exact difference between call and delegatecall in the EVM, why storage context changes everything, and how this powers proxy upgrade patterns while creating storage-collision risks.',
  //   featured: true,
  //   // Content is rendered by the CallVsDelegatecall component directly in ArticleModal
  //   content: '',
  // },

};
